export default "__VITE_ASSET__C73QP0UV__"